export default class GoogleSignInButton {
	constructor(form) {
		this.form = form;
		const button = form.querySelector('div');

		let initializationObject = Object.assign({}, button.dataset);
		initializationObject.width = button.parentElement.offsetWidth;

		// Initialization according to:
		// https://developers.google.com/identity/gsi/web/guides/display-button#javascript
		google.accounts.id.initialize({
			client_id: button.dataset.initialization_client_id,
			callback: this.handleCredentialResponse.bind(this)
		});

		google.accounts.id.renderButton(button, initializationObject);

		window.addEventListener('resize', () => {
			initializationObject.width = button.parentElement.offsetWidth;
			google.accounts.id.renderButton(button, initializationObject);
		});
	}

	handleCredentialResponse(response) {
		this.form.querySelector('[name="credential"]').value =
			response['credential'];
		this.form.submit();
	}
}
